<template>
  <span :class="{ 'icon-caret_up_down': !show }" class="icon i-lg">
    <span v-if="asc && show" class="icon i-lg icon-caret_down"></span>
    <span v-if="!asc && show" class="icon i-lg icon-caret_up"></span>
  </span>
</template>

<script>
export default {
  name: "ListSortingArrows",
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    asc: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
